"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBox = exports.ThirdLargeText = exports.SecondLargeText = exports.FirstLargeText = exports.Third = exports.Second = exports.First = exports.Square = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.Square = styled_components_1.default.div `
  height: 100%;
  width: 100%;
  color: rgba(0, 0, 0, 0.54);
  background-color: rgb(238, 238, 238);
  border-radius: 6px;
  text-align: center;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  padding: 16px;
`;
exports.First = styled_components_1.default.div `
  padding: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
`;
exports.Second = styled_components_1.default.div `
  padding: 16px;
  padding-top: 20px;
  padding-bottom: 20px;
`;
exports.Third = styled_components_1.default.div `
  padding: 16px;
  padding-top: 30px;
  padding-bottom: 30px;
`;
exports.FirstLargeText = styled_components_1.default.div `
  padding: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 3em;
`;
exports.SecondLargeText = styled_components_1.default.div `
  padding: 16px;
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 3em;
`;
exports.ThirdLargeText = styled_components_1.default.div `
  padding: 16px;
  padding-top: 30px;
  padding-bottom: 30px;
  font-size: 3em;
`;
const getContainer = (container) => container
    ? (0, styled_components_1.css) `
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
      `
    : '';
const getItem = (item) => item
    ? (0, styled_components_1.css) `
        box-sizing: border-box;
        margin: 0;
      `
    : '';
const getItemOrder = (item, order) => item && order
    ? (0, styled_components_1.css) `
        order: ${order};
      `
    : '';
const getZeroMinWidth = (zeroMinWidth) => zeroMinWidth
    ? (0, styled_components_1.css) `
        min-width: 0;
      `
    : '';
const getBoxSpacing = (container, spacing) => {
    if (container && spacing) {
        const margin = spacing;
        const widthOffset = spacing * 2;
        const padding = spacing;
        return (0, styled_components_1.css) `
      margin: -${margin}px;
      width: calc(100% + ${widthOffset}px);

      & > .lp-box-item {
        padding: ${padding}px;
      }
    `;
    }
    return '';
};
const getFlexStyle = (cssProperty, cssValue, skipValue) => {
    if (cssValue && cssValue !== skipValue) {
        return (0, styled_components_1.css) `
      ${cssProperty}: ${cssValue};
    `;
    }
    return '';
};
const getBoxSize = (size, breakpoint) => {
    let flexBasis, flexGrow, maxWidth = 'initial';
    if (size === 'auto') {
        flexBasis = 'auto';
        flexGrow = '0';
        maxWidth = 'none';
    }
    else if (size === true) {
        flexBasis = '0';
        flexGrow = '1';
        maxWidth = '100%';
    }
    else if (typeof size === 'number') {
        flexBasis = `${(100 / 12) * size}%`;
        flexGrow = '0';
        maxWidth = `${(100 / 12) * size}%`;
    }
    else if (!size) {
        return '';
    }
    const styles = (0, styled_components_1.css) `
    flex-basis: ${flexBasis};
    flex-grow: ${flexGrow};
    max-width: ${maxWidth};
  `;
    return breakpoint
        ? (0, styled_components_1.css) `
        @media (min-width: ${breakpoint}) {
          ${styles}
        }
      `
        : styles;
};
exports.StyledBox = styled_components_1.default.div `
  ${(props) => getContainer(props.container)}
  ${(props) => getItem(props.item)}
  ${(props) => getItemOrder(props.item, props.order)}
  ${(props) => getZeroMinWidth(props.zeroMinWidth)}
  ${(props) => getBoxSpacing(props.container, props.spacing)}
  ${(props) => getFlexStyle('flex-direction', props.direction, 'row')}
  ${(props) => getFlexStyle('flex-wrap', props.wrap, 'wrap')}
  ${(props) => getFlexStyle('align-items', props.alignItems, 'stretch')}
  ${(props) => getFlexStyle('align-content', props.alignContent, 'stretch')}
  ${(props) => getFlexStyle('justify-content', props.justify, 'flex-start')}
  ${(props) => {
    const { breakpoints } = props;
    return breakpoints
        ? (0, styled_components_1.css) `
          ${getBoxSize(props.xs)}
          ${getBoxSize(props.sm, breakpoints.sm)}
          ${getBoxSize(props.md, breakpoints.md)}
          ${getBoxSize(props.lg, breakpoints.lg)}
          ${getBoxSize(props.xl, breakpoints.xl)}
        `
        : '';
}}
`;
